import {getPaymentStatusConfig as getPaymentStatusConfigUtil} from '../../utils/paymentStatusUtils';

// دالة لتحديد إعدادات حالة الدفع
export const getPaymentStatusConfig = (status: string | undefined | null) => {
  return getPaymentStatusConfigUtil(status);
};
